import { useCallback } from "react"
import { graphql, UseMutationConfig } from "react-relay"
import { type CustomMutationParams, useMutationWithErrorDialog } from "@/hooks/useMutationWithErrorDialog"
import { useChCreateNeuropsychologicDiagnosticPrescriptionMutation as useChCreateNeuropsychologicDiagnosticPrescriptionMutationType } from "@/modules/patients/detail/neuropsychologic-diagnostic-prescription/ch/services/__generated__/useChCreateNeuropsychologicDiagnosticPrescriptionMutation.graphql"

const mutation = graphql`
  mutation useChCreateNeuropsychologicDiagnosticPrescriptionMutation(
    $input: Ch_createNeuropsychologicDiagnosticPrescriptionInput!
  ) {
    ch_createNeuropsychologicDiagnosticPrescription(input: $input) {
      ch_NeuropsychologicDiagnosticPrescription {
        id
        ...chNeuropsychologicDiagnosticPrescriptionDrawerFragment
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`

const useChCreateNeuropsychologicDiagnosticPrescriptionMutation = (params?: CustomMutationParams) => {
  const [commit, isFlight] = useMutationWithErrorDialog<useChCreateNeuropsychologicDiagnosticPrescriptionMutationType>(
    mutation,
    params,
  )

  const commitHandler = useCallback(
    (config: UseMutationConfig<useChCreateNeuropsychologicDiagnosticPrescriptionMutationType>) => {
      commit(config)
    },
    [commit],
  )

  return [commitHandler, isFlight] as const
}

export { useChCreateNeuropsychologicDiagnosticPrescriptionMutation }
